import { useForm } from 'react-hook-form'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { UseActiveUser } from '../../../store/user.store'

import { AutenticacaoModel } from '@/@types/Models'
import { api } from '@/api/api'
import { rotasApi } from '@/configurações/rotasApi'
import { rotasApp } from '@/configurações/rotasApp'
import {
  responseError,
  responseSuccess,
} from '@/utilitários/handler/responseHandler'
import { LocalStorage } from '@/utilitários/localStorage/LocalStorage'
import { toastUi } from '@/utilitários/toast'
import { zodResolver } from '@hookform/resolvers/zod'
import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { z } from 'zod'

export const useLoginWithGoogle = () => {
  const { setUserActive } = UseActiveUser()
  const storage = new LocalStorage()
  const [searchBarParams] = useSearchParams()
  const navigate = useNavigate()

  const { mutate: loginWithGoogle, isLoading: isLoadingLoginWithGoogle } =
    useMutation(signIn, {
      onSuccess: async (data) => {
        if (data.acesso === 'administrador') {
          return toastUi({
            title: 'Acesso negado',
            description: 'Uma conta é necessária para acessar o sistema',
            duration: 25000,
            type: 'error',
          })
        }
        //await queryClient.invalidateQueries(['me'])
        setUserActive(data)
        if (data?.token) storage.set('@Esforce:Auth-Token', data.token)
        api().interceptors.request.use((config) => {
          if (config.headers) {
            config.headers.Authorization = ` Bearer ${data.token};`
          }
          return config
        })
        responseSuccess('Login realizado')
        navigate(searchBarParams.get('redirect') || rotasApp.início)
      },
      onError: (error: AxiosError) => responseError(error),
    })

  const loginWithGoogleContext = useForm<LoginWithGoogleSchema>({
    resolver: zodResolver(loginWithGoogleSchema),
    reValidateMode: 'onChange',
  })

  return { loginWithGoogle, isLoadingLoginWithGoogle, loginWithGoogleContext }
}

async function signIn(
  dataNew: LoginWithGoogleSchema,
): Promise<AutenticacaoModel> {
  const data = {}
  const headers = {
    'google-id-token': dataNew.tokenGoogleId,
  }
  const result = await api().post(rotasApi.signIn, data, { headers })
  return result.data.data
}

const loginWithGoogleSchema = z.object({
  tokenGoogleId: z.string().optional().nullable(),
})

export type LoginWithGoogleSchema = z.infer<typeof loginWithGoogleSchema>
